import { Box, Flex, type BoxProps, type FlexProps } from '@chakra-ui/react';
import type { Ref } from 'react';

export interface ItemListProps extends Omit<FlexProps, 'title'> {
  ref?: Ref<HTMLDivElement>;
  icon?: React.ReactNode;
  title?: React.ReactNode;
  description?: React.ReactNode;
  descriptionProps?: BoxProps;
  iconProps?: BoxProps;
  contentProps?: FlexProps;
  endElement?: React.ReactNode;
  endElementProps?: BoxProps;
}

export function ItemList({
  icon,
  title,
  description,
  descriptionProps,
  iconProps,
  contentProps,
  endElement,
  endElementProps,
  ...props
}: ItemListProps) {
  return (
    <Flex
      className="ItemList"
      gap="2.5"
      py="2"
      pl="3"
      pb="0"
      borderRadius="xl"
      cursor="pointer"
      _hover={{ bg: 'grey.10' }}
      justifyContent="space-between"
      alignItems="center"
      {...props}
    >
      {icon && (
        <Box fontSize="36px" pb="3.5" flex="0 0 auto" {...iconProps}>
          {icon}
        </Box>
      )}
      <Flex
        className="ItemListContent"
        gap="2.5"
        minW="0"
        flex="1 1 auto"
        pb="3.5"
        borderBottom="1px solid"
        borderColor="grey.10"
        {...contentProps}
      >
        <Box flex="1" minW="0" overflow="hidden">
          <Box fontSize="sm" fontWeight="semibold" truncate>
            {title}
          </Box>
          {description && (
            <Box
              fontSize="xs"
              fontWeight="medium"
              color="fg.subtle"
              minW="0"
              truncate
              {...descriptionProps}
            >
              {description}
            </Box>
          )}
        </Box>
        <Box
          className="ItemListEndElement"
          fontSize="xs"
          fontWeight="medium"
          textAlign="right"
          pr="3"
          flex="0 0 auto"
          {...endElementProps}
        >
          {endElement}
        </Box>
      </Flex>
    </Flex>
  );
}
